import { Link } from 'react-router-dom';

const cards = [
  {
    title: 'Тренинг для руководителей',
    desc: 'Комплексное развитие управленческих компетенций для руководителей всех уровней.',
    href: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley',
  },
  {
    title: 'Мотивация и управление командой',
    desc: 'Как руководителю создавать условия для самостоятельной и результативной работы команды.',
    href: '/menedzhment-i-liderstvo/motivatsiya-i-upravlenie-komandoy',
  },
  {
    title: 'Управление конфликтами',
    desc: 'Как работать с разногласиями и предотвращать разрушительные конфликты в команде.',
    href: '/menedzhment-i-liderstvo/trening-po-upravleniyu-konfliktami',
  },
  {
    title: 'Обратная связь и сложные разговоры',
    desc: 'Как менять поведение сотрудников через качественную обратную связь.',
    href: '/menedzhment-i-liderstvo/obratnaya-svyaz-i-slozhnye-razgovory',
  },
  {
    title: 'Руководитель в переговорах',
    desc: 'Как руководителю отстаивать интересы бизнеса и добиваться договорённостей.',
    href: '/menedzhment-i-liderstvo/rukovoditel-v-peregovorah',
  },
];

export default function ReadNextSection() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Что изучить дальше
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Другие направления развития руководителей и управленческих команд
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {cards.map((card) => (
            <Link
              key={card.href + card.title}
              to={card.href}
              className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors group cursor-pointer"
            >
              <h3 className="font-bold text-gray-900 text-sm mb-2 group-hover:text-teal-600 transition-colors">{card.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed mb-3">{card.desc}</p>
              <span className="inline-flex items-center gap-1 text-xs font-semibold text-teal-600">
                Подробнее
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}